import React, { useEffect, useState } from 'react';

const NullCheckbox = ({
  fieldName,
  wrapperClass = '',
  label = '',
  allowNull = true,
  value = 'off',
  errors = [],
  helpText = '',
  additionalClass = '',
  parent = '',
  onChange = () => {},
  pk = null
}) => {
  const [inputValue, setInputValue] = useState(value);
  const localOnChange = (e) => {
      setInputValue(e.target.value)
      onChange({'name':fieldName, 'value': e.target.value, 'label': e.target.value})
  }
  useEffect(() => {
      setInputValue(value)
  }, [value])

  return (<>
        <input 
          className={`form-check-input ${additionalClass} ${errors.length > 0 ? 'has-error is-invalid' : ''}`}
          type="checkbox" 
          id={pk ? pk + '_' + fieldName : fieldName}
          checked={inputValue === 'on' || inputValue === true}
          onChange={localOnChange}
          />
    </>
  );
};

export default NullCheckbox;
